import moment from 'moment';

export default class AppController
{
	constructor($scope, AppService, DatePickerService) {
		this.$scope = $scope;
		this.AppService = AppService;

		this.menuToggle = false;
		this.modal = false;

		// Initialise datepicker service
		DatePickerService.init();

		DatePickerService.rangePicker.on('apply.daterangepicker', (ev, picker) => {
			// Set base date range
			DatePickerService.dateRange.startDate = picker.startDate;
			DatePickerService.dateRange.endDate = picker.endDate;

			// // If compare checkbox is not selected, pre-define compare dates to 1 year before base date
			if (!this.AppService.compare) {
				let startDate = picker.startDate.format();
				let endDate = picker.endDate.format();

				let compareStartDate = moment(startDate).subtract(1, 'year');
				let compareEndDate = moment(endDate).subtract(1, 'year');

				DatePickerService.dateRange.compareStartDate = compareStartDate;
				DatePickerService.dateRange.compareEndDate = compareEndDate;

				DatePickerService.compareRangePicker.data('daterangepicker').setStartDate(DatePickerService.dateRange.compareStartDate.format('YYYY-MM-DD'));
				DatePickerService.compareRangePicker.data('daterangepicker').setEndDate(DatePickerService.dateRange.compareEndDate.format('YYYY-MM-DD'));
				DatePickerService.compareRangeCallBack(DatePickerService.dateRange.compareStartDate, DatePickerService.dateRange.compareEndDate);
			}

			$scope.$broadcast('base-range-update');
		});

		DatePickerService.compareRangePicker.on('apply.daterangepicker', (ev, picker) => {
			// Set compare date range
			DatePickerService.dateRange.compareStartDate = picker.startDate;
			DatePickerService.dateRange.compareEndDate = picker.endDate;
			$scope.$broadcast('compare-range-update');
		});
	}

	toggleCompareRange() {
		this.$scope.$broadcast('all-range-update');
		window.dispatchEvent(new Event('resize'));
	}

	toggleMenu() {
		this.menuToggle = this.menuToggle ? false : true;
		if (this.menuToggle) {
			$('#main-menu-wrapper').removeClass('medium-2').hide();
			$('#content-wrapper').removeClass('medium-10').addClass('medium-12');
		} else {
			$('#main-menu-wrapper').addClass('medium-2').show();
			$('#content-wrapper').removeClass('medium-12').addClass('medium-10');
		}
		window.dispatchEvent(new Event('resize'));
	}

	closeModal() {
		this.modal = false;
	}

	openModal() {
		this.modal = true;
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/app.controller.js
 **/